export default __webpack_public_path__ + "827bc8699f345943a9260513b94038eb.png";